import {
  Stack,
  Radio,
  RadioGroup,
  Divider,
  Typography,
  Grid,
  FormControlLabel,
  FormGroup,
  Checkbox,
  Chip,
  Button,
  Box,
} from "@mui/material";

import { useState, useEffect, useRef } from "react";
import { useNavigate, generatePath } from "react-router-dom";
import api from "../../services/api";

import { ReactComponent as IconDiamond } from "../../images/icon-diamond.svg";
import { formatDateISO8601 } from "../../utils/formatarData";
import { ufList } from "../../utils/ufList";
import { calcularDiferencaEmAnos } from "../../utils/diferencaEntreDatas";
import { requestPrimeiraConsultaDadosClinicos } from "../../services/cadastroService";
import CardPaciente from "../../components/CardPaciente";
import {
  FieldSelect,
  FieldInputMask,
  FieldDatePicker,
  FieldInputText,
  FieldAutocomplete,
} from "../../components/Fields";
import { getDadosRegistro } from "../../services/getRegistroApi";
import { gerarIdentificador } from "../../utils/gerarIdentificadorPaciente";
import InserirDadosRegistro from "./inserirDadosRegistro";
import PreencherRespostas from "./preencherRespostas";
import {
  antecedentepessoaisList,
  comorbidadesList,
  regiaoSintomasList,
  sinaisSintomasList,
} from "./data";

import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import ButtonGoBack from "../../components/Buttons/outlinedGoback";
import ModalDialogs from "../../components/ModalDialogs";
import { getItemDecrypt } from "../../utils/cryptoData";

const styles = {
  title: {
    fontWeight: "300",
    fontSize: "32px",
    lineHeight: "25px",
    color: "#063F5E",
  },
  formTitle: {
    fontWeight: "bold",
    fontSize: "1.2rem",
    lineHeight: "25px",
    color: "#1E729F",
  },
  subtitle: {
    fontWeight: "500",
    fontSize: "20px",
    lineHeight: "27px",
    marginBottom: "15px",
    marginTop: "20px",
    color: "#3E94C2",
  },
  titleForms: {
    fontFamily: "Nunito",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "22px",
    letterSpacing: "0em",
    textAlign: "left",
    color: "#063F5E",
    marginBottom: "16px",
  },
};

export default function PrimeiraAvaliacao({ idPaciente }) {
  const navigate = useNavigate();
  const [anamnese, setAnamnese] = useState("");

  const [estadoInicioDoenca, setEstadoInicioDoenca] = useState("");
  const [municipioInicioDoenca, setMunicipioInicioDoenca] = useState("");
  const [municipioList, setMunicipioList] = useState([]);
  const [tempoMoradiaMunicipio, setTempoMoradiaMunicipio] = useState("");
  const [localPrimeiroSintoma, setLocalPrimeiroSintoma] = useState("");
  const [dataPrimeiroSintoma, setDataPrimeiroSintoma] = useState("");
  const [idadeInicioSintomas, setIdadeInicioSintomas] = useState("");
  const [altura, setAltura] = useState();
  const [peso, setPeso] = useState("000000");
  const [pesoOnFocus, setPesoOnFocus] = useState(false);
  const [imc, setImc] = useState(0);
  const [sinaisSintomas, setSinaisSintomas] = useState([]);
  const [sinaisSintomasOutros, setSinaisSintomasOutros] = useState("");
  const [antecedentesPessoais, setAntecedentesPessoais] = useState([]);
  const [antecedentesPessoaisOutros, setAntecedentesPessoaisOutros] =
    useState("");
  const [comorbidadesSelecionadas, setComorbidadesSelecionadas] = useState([]);
  const [comorbidadesOutras, setComorbidadesOutras] = useState([]);
  const [historicoFamiliarELA, setHistoricoFamiliarELA] = useState([]);
  const [historicoFamiliarELAOutros, setHistoricoFamiliarELAOutros] =
    useState("");
  const [historicoFamiliarDemencia, setHistoricoFamiliarDemencia] = useState(
    []
  );
  const [historicoFamiliarDemenciaOutros, setHistoricoFamiliarDemenciaOutros] =
    useState("");
  const [
    historicoFamiliarDoencaPsiquiatrica,
    setHistoricoFamiliarDoencaPsiquiatrica,
  ] = useState([]);
  const [
    historicoDoencaPsiquiatricaOutros,
    setHistoricoDoencaPsiquiatricaOutros,
  ] = useState([]);
  const [dataNascimento, setDataNascimento] = useState("");
  const [medicamentosList, setMedicamentosList] = useState([]);
  const [substanciasList, setSubstanciasList] = useState([]);
  const [medicamentosUsados, setMedicamentosUsados] = useState([]);
  const [CIDList, setCIDList] = useState([]);
  const [loading, setLoading] = useState(true);

  const [alergiasOuReacoes, setAlergiasOuReacoes] = useState({
    alimentos: [],
    medicamentos: [],
    outros: [],
  });

  const [observacoes, setObservacoes] = useState([]);

  const [modalSuccess, setModalSuccess] = useState(false);

  const [cirurgias, setCirurgias] = useState({
    checked: undefined,
    qual: "",
    dataCirurgia: "",
    tagCirurgias: [],
  });

  const [usoRiluzol, setUsoRiluzol] = useState({
    checked: undefined,
    dataInicioUso: "",
  });

  const [checks, setChecks] = useState({
    alimentos: false,
    medicamentos: false,
    outros: false,
    historicoELA: undefined,
    historicoDemencia: undefined,
    historicoDoencaPsiquiatrica: undefined,
    etilismo: false,
    contatoComInseticidas: false,
    ContatoMetaisPesados: false,
    alergiasOuReacoes: undefined,
  });

  const [stateModal, setStateModal] = useState({
    open: false,
    title: "",
    bodyText: "",
    modalType: "",
  });
  const inputRef = useRef(null);

  useEffect(() => {
    fecthData();
  }, []);

  const fecthData = async () => {
    try {
      setLoading(true);
      await Promise.all([
        getDadosPaciente(),
        getMedicamentosList(),
        getSubstanciasList(),
        getCIDList(),
      ]);
    } catch (error) {
      console.error("Erro ao tentar conectar-se ao servidor.", error.message);
      setStateModal({
        open: true,
        title: "Error",
        bodyText: "Erro ao tentar conectar-se ao servidor.",
        modalType: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const sinaisSintomasOpcaoSelecionada = (valor) => {
    return sinaisSintomas.includes(valor);
  };

  const antecedentesPessoaisSelecionada = (valor) => {
    return antecedentesPessoais.includes(valor);
  };

  const comorbidadeOpcaoSelecionada = (valor) => {
    return comorbidadesSelecionadas.includes(valor);
  };

  const historicoDoencaPsiquiatricaOpcaoSelecionada = (valor) => {
    return historicoFamiliarDoencaPsiquiatrica.includes(valor);
  };

  const historicoELAOpcaoSelecionada = (valor) => {
    return historicoFamiliarELA.includes(valor);
  };

  const historicoDemenciaOpcaoSelecionada = (valor) => {
    return historicoFamiliarDemencia.includes(valor);
  };

  async function getDadosPaciente() {
    try {
      const { data } = await api.get(`/dadospaciente/${idPaciente}`);

      const dataNascimentoFormatada = formatDateISO8601(data.dataNascimento);
      setDataNascimento(dataNascimentoFormatada);

      const identificador = gerarIdentificador(data);
      const dadosPaciente = await getDadosRegistro(identificador);
      const dadosPrimeiraAvaliacao = await getDadosPrimeiraAvaliacao();

      const campos = {
        setEstadoInicioDoenca,
        setMunicipioInicioDoenca,
        fetchMunicipio,
        setTempoMoradiaMunicipio,
        setLocalPrimeiroSintoma,
        setDataPrimeiroSintoma,
        setIdadeInicioSintomas,
        setComorbidadesSelecionadas,
        setComorbidadesOutras,
        setChecks,
        setHistoricoFamiliarELA,
        setHistoricoFamiliarDemencia,
        setUsoRiluzol,
      };

      if (dadosPaciente) {
        InserirDadosRegistro(dadosPaciente, campos);
      }

      if (dadosPrimeiraAvaliacao && dadosPrimeiraAvaliacao.length > 0) {
        const camposAdicionais = {
          setAnamnese,
          setAltura,
          setPeso,
          setImc,
          setSinaisSintomas,
          setSinaisSintomasOutros,
          setAntecedentesPessoais,
          setAntecedentesPessoaisOutros,
          setCirurgias,
          setHistoricoFamiliarDoencaPsiquiatrica,
          setHistoricoDoencaPsiquiatricaOutros,
          setHistoricoFamiliarELAOutros,
          setHistoricoFamiliarDemenciaOutros,
          setMedicamentosUsados,
          setAlergiasOuReacoes,
          setObservacoes,
          setChecks,
        };

        const todosCampos = { ...campos, ...camposAdicionais };

        PreencherRespostas(dadosPrimeiraAvaliacao, todosCampos);
      }
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getDadosPrimeiraAvaliacao() {
    try {
      const { data } = await api.post(
        `/respostas-primeira-consulta/${idPaciente}`
      );
      if (data) {
        return data.question;
      }
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getMedicamentosList() {
    try {
      const { data } = await api.post("/medicamentos/", {
        descricao: "",
        apenasNome: true,
      });

      setMedicamentosList(data.medicines);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getSubstanciasList() {
    try {
      const { data } = await api.post("/medicamentos/", {
        descricao: "",
        apenasSubstancia: true,
      });

      setSubstanciasList(data.medicines);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getCIDList() {
    try {
      const { data } = await api.get("/buscacid/");
      setCIDList(data.cids);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  useEffect(() => {
    const kilo = peso.slice(0, 3);
    const grama = peso.slice(3);
    const newPeso = parseFloat(`${kilo}.${grama}`);

    const newAltura = parseFloat(altura);

    if (!isNaN(newPeso) && !isNaN(newAltura) && newPeso > 0 && newAltura > 0) {
      const calcImc = newPeso / (newAltura * newAltura);
      setImc(calcImc.toFixed(2));
    } else {
      setImc();
    }
  }, [altura, peso]);

  const handleSinaisSintomas = (e) => {
    const { value, checked } = e.target;

    if (checked) {
      setSinaisSintomas([...sinaisSintomas, value]);
    } else {
      setSinaisSintomas(sinaisSintomas.filter((e) => e !== value));
    }
  };

  const handleChangeTempoCirurgia = (e) => {
    try {
      const month = String(e.month() + 1).padStart(2, "0");
      const year = e.year();
      const dataCirurgia = `${month}/${year}`;

      setCirurgias((prevState) => ({
        ...prevState,
        dataCirurgia: dataCirurgia,
      }));
    } catch (error) {
      console.error("data tempo de cirurgia invalido");
    }
  };

  const handleAdicionarCirurgia = () => {
    if (cirurgias.qual !== "" && cirurgias.dataCirurgia !== "") {
      setCirurgias((prevState) => ({
        ...prevState,
        qual: "",
        dataCirurgia: "",
        tagCirurgias: [
          ...prevState.tagCirurgias,
          `${cirurgias.qual} - ${cirurgias.dataCirurgia}`,
        ],
      }));
    } else {
      setStateModal({
        open: true,
        title: "Cirurgia    ",
        bodyText:
          cirurgias.qual === ""
            ? "Informe o nome da cirurgia."
            : "Informe a data da cirurgia.",
        modalType: "warning",
      });
    }
  };

  const handleAntecedentes = (e) => {
    const { value, checked } = e.target;

    if (checked) {
      setAntecedentesPessoais([...antecedentesPessoais, value]);
    } else {
      setAntecedentesPessoais(antecedentesPessoais.filter((e) => e !== value));
    }
  };

  const handleComorbidades = (e) => {
    const { value, checked } = e.target;

    if (checked) {
      setComorbidadesSelecionadas([...comorbidadesSelecionadas, value]);
    } else {
      setComorbidadesSelecionadas(
        comorbidadesSelecionadas.filter((e) => e !== value)
      );
    }
  };

  const handleHistoricoDoencaPsiquiatrica = (e) => {
    const { value, checked } = e.target;

    if (checked) {
      setHistoricoFamiliarDoencaPsiquiatrica([
        ...historicoFamiliarDoencaPsiquiatrica,
        value,
      ]);
    } else {
      setHistoricoFamiliarDoencaPsiquiatrica(
        historicoFamiliarDoencaPsiquiatrica.filter((e) => e !== value)
      );
    }
  };

  const handleHistoricoFamiliarELA = (e) => {
    const { value, checked } = e.target;

    if (checked) {
      setHistoricoFamiliarELA([...historicoFamiliarELA, value]);
    } else {
      setHistoricoFamiliarELA(historicoFamiliarELA.filter((e) => e !== value));
    }
  };

  const handleHistoricoFamiliarDemencia = (e) => {
    const { value, checked } = e.target;

    if (checked) {
      setHistoricoFamiliarDemencia([...historicoFamiliarDemencia, value]);
    } else {
      setHistoricoFamiliarDemencia(
        historicoFamiliarDemencia.filter((e) => e !== value)
      );
    }
  };

  const selecionarComorbidadesOutras = () => {
    return comorbidadesOutras.map((comorb) => {
      if (comorb.co_categoria) {
        return `${comorb.co_categoria} - ${comorb.no_categoria}`;
      } else {
        return comorb;
      }
    });
  };

  const mostrarLabelComorbidadesOutras = (comorb) => {
    if (comorb.co_categoria) {
      return `${comorb.co_categoria} - ${comorb.no_categoria}`;
    } else {
      return comorb;
    }
  };

  const atualizarComorbidadesOutras = (v) => {
    if (v.no_descricao) {
      setComorbidadesOutras((prevState) =>
        comorbidadesOutras.filter(
          (data) => data.no_categoria !== v.no_categoria
        )
      );
    } else {
      setComorbidadesOutras((prevState) =>
        comorbidadesOutras.filter((data) => data !== v)
      );
    }
  };

  const opcaoSimNaoSelecionada = (resposta) => {
    if (resposta) {
      return "50";
    }

    if (resposta === null || resposta === undefined || resposta === "") {
      return "";
    }

    return "51";
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    let vinculo = getItemDecrypt("vinculo_ativo");

    let currentPeso = peso.replace(/\D/g, "");

    if (currentPeso !== "000000") {
      if (parseInt(peso.slice(0, 3)) < 30 || parseInt(peso.slice(0, 3)) > 250) {
        setStateModal({
          open: true,
          title: "Ops!!",
          bodyText: "Por favor, preencha o campo do peso corretamente.",
          modalType: "warning",
        });
        return;
      }
    }

    const data = {
      id_vinculo: vinculo.id,
      id_paciente: parseInt(idPaciente),
      nu_consulta: 0,
      anamnese,
      estadoInicioDoenca,
      municipioInicioDoenca,
      tempoMoradiaMunicipio,
      localPrimeiroSintoma,
      dataPrimeiroSintoma: `${dataPrimeiroSintoma}-01`,
      idadeInicioSintomas,
      altura,
      peso:
        currentPeso !== "000000"
          ? `${currentPeso.slice(0, 3)},${currentPeso.slice(3)}`
          : "",
      imc,
      sinaisSintomas,
      sinaisSintomasOutros,
      antecedentesPessoais,
      antecedentesPessoaisOutros,
      comorbidadesSelecionadas,
      comorbidadeOutras: selecionarComorbidadesOutras(),
      possuiCirurgias: cirurgias.checked ? "50" : "51",
      listagemCirurgias: cirurgias.tagCirurgias,
      historicoFamiliarELA: opcaoSimNaoSelecionada(checks.historicoELA),
      historicoFamiliarELAQuem: checks.historicoELA ? historicoFamiliarELA : [],
      historicoFamiliarELAOutros: checks.historicoELA
        ? historicoFamiliarELAOutros
        : "",
      historicoFamiliarDemencia: opcaoSimNaoSelecionada(
        checks.historicoDemencia
      ),
      historicoFamiliarDemenciaQuem: checks.historicoDemencia
        ? historicoFamiliarDemencia
        : [],
      historicoFamiliarDemenciaOutros: checks.historicoDemencia
        ? historicoFamiliarDemenciaOutros
        : "",
      historicoFamiliarDoencaPsiquiatrica: opcaoSimNaoSelecionada(
        checks.historicoDoencaPsiquiatrica
      ),
      historicoFamiliarDoencaPsiquiatricaQuem:
        checks.historicoDoencaPsiquiatrica
          ? historicoFamiliarDoencaPsiquiatrica
          : [],
      historicoDoencaPsiquiatricaOutros: checks.historicoDoencaPsiquiatrica
        ? historicoDoencaPsiquiatricaOutros
        : "",
      usaRiluzol: usoRiluzol.checked ? "50" : "51",
      dataRiluzol: usoRiluzol.dataInicioUso,
      medicamentosUsados,
      alergiaAlimentos: checks.alergiasOuReacoes
        ? alergiasOuReacoes.alimentos
        : [],
      alergiaMedicamentos: checks.alergiasOuReacoes
        ? alergiasOuReacoes.medicamentos
        : [],
      alergiaOutros: checks.alergiasOuReacoes ? alergiasOuReacoes.outros : [],
      observacoes,
    };

    const idConsulta = await requestPrimeiraConsultaDadosClinicos(data);
    if (idConsulta) {
      try {
        const FINALIZADA = 3;
        await api.put("/consulta/", {
          id_consulta_evolucao: idConsulta.co_id,
          id_status: FINALIZADA,
        });
        setModalSuccess(true);
      } catch (error) {
        console.error("Ocorreu um erro:", error.message);
      }
    }
  };

  async function fetchMunicipio(uf) {
    const data = await api.post("/city", {
      state_id: parseInt(uf),
    });
    setMunicipioList(data.data);
  }

  function handleDataPrimeiroSintoma(e) {
    try {
      const month = String(e.month() + 1).padStart(2, "0");
      const year = e.year();
      const inicioSintomas = `${year}-${month}-01`;

      setDataPrimeiroSintoma(`${year}-${month}`);
      const idadeDeInicioSintomas = calcularDiferencaEmAnos(
        dataNascimento,
        inicioSintomas
      );

      setIdadeInicioSintomas(idadeDeInicioSintomas);
    } catch (error) {
      console.error("data invalida");
    }
  }

  const handleClick = () => {
    if (inputRef.current) {
      setTimeout(() => {
        inputRef.current.setSelectionRange(7, 7);
      }, 80);
    }
  };
  function handlePeso(e) {
    if (e.key >= "0" && e.key <= "9") {
      setPeso((oldValue) => {
        const newPeso = (oldValue + e.key).slice(-6);
        return newPeso.padStart(6, "0");
      });
    } else if (e.key === "Backspace") {
      if (peso !== "000000") {
        setPeso((oldValue) => {
          const newPeso = "0" + oldValue.slice(0, -1);
          return newPeso.padStart(6, "0");
        });
      }
    } else if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
      e.preventDefault();
    }
  }

  if (!loading) {
    return (
      <Box>
        <Box>
          <ButtonGoBack />

          <Box>
            <Box style={styles.title}>Prontuário do paciente</Box>
          </Box>

          <CardPaciente id={idPaciente} />

          <Box
            sx={{
              boxShadow: "0px 1px 8px 0px #00000026",
              boxSizing: "border-box !important",
              padding: "30px 24px",
              margin: "32px 0px",
              borderRadius: "8px",
              width: "100%",
            }}
          >
            <Typography style={styles.subtitle}>
              Primeira avaliação - Dados clínicos
            </Typography>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <Stack sx={{ mb: 2, mt: 1 }}>
                <Grid container direction="row" alignItems="center">
                  Anamnese
                </Grid>
                <textarea
                  value={anamnese}
                  onChange={(e) => {
                    setAnamnese(e.target.value);
                  }}
                  style={{
                    height: "5rem",
                    border: "1px solid #1E729F",
                    borderRadius: "5px",
                    padding: 10,
                    resize: "vertical",
                  }}
                  variant="outlined"
                  placeholder="Descreva as queixas do paciente e suas observações sob o quadro"
                />
              </Stack>

              <Stack
                sx={{
                  gap: "16px 24px",
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                  boxSizing: "border-box !important",
                  marginBottom: "20px",
                  alignItems: "end",
                }}
              >
                <FieldSelect
                  label="Estado de residência onde iniciou a doença"
                  required
                  value={estadoInicioDoenca}
                  setValue={(value) => {
                    setEstadoInicioDoenca(value);
                    fetchMunicipio(value);
                  }}
                  items={ufList.map((item) => {
                    return {
                      id: item.codigo_uf,
                      label: item.unidade_federativa,
                    };
                  })}
                />

                <FieldSelect
                  label="Município de residência onde iniciou a doença"
                  required
                  value={municipioInicioDoenca}
                  setValue={(value) => {
                    setMunicipioInicioDoenca(value);
                  }}
                  items={municipioList.map((item) => {
                    return {
                      id: item.co_ibge,
                      label: item.no_descricao,
                    };
                  })}
                />

                <FieldInputMask
                  label="Tempo de moradia nesse município"
                  mask="99 Ano(s) e 99 meses"
                  value={tempoMoradiaMunicipio}
                  setValue={(value) => setTempoMoradiaMunicipio(value)}
                  required
                />

                <FieldSelect
                  label="Local do primeiro sintoma"
                  required
                  value={localPrimeiroSintoma}
                  setValue={(value) => {
                    setLocalPrimeiroSintoma(value);
                  }}
                  items={regiaoSintomasList.map((item) => {
                    return {
                      id: item.value,
                      label: item.label,
                    };
                  })}
                />

                <FieldDatePicker
                  label="Data do primeiro sintoma"
                  value={dataPrimeiroSintoma}
                  setValue={handleDataPrimeiroSintoma}
                  openTo="year"
                  labelDatePicker={"mês de ano"}
                  views={["year", "month"]}
                  maxDate={dayjs(new Date())}
                  minDate={dayjs(dataNascimento)}
                  format="MMMM YYYY"
                  required
                />
                <FieldInputText
                  label="Idade no início dos sintomas"
                  type="number"
                  disabled
                  value={idadeInicioSintomas}
                  setValue={(value) => {}}
                />
                <FieldInputMask
                  label="Altura (m)"
                  mask="9,99"
                  value={altura}
                  setValue={(value) => setAltura(value.replace(",", "."))}
                  required
                  placeholder="Ex: 1,90"
                  helperText={" "}
                />
                <FieldInputMask
                  label="Peso habitual (Kg)"
                  mask="999,999"
                  placeholder="Ex: 085,900"
                  value={peso === "000000" && !pesoOnFocus ? "" : peso}
                  inputProps={{
                    ref: inputRef,
                  }}
                  onClick={handleClick}
                  onKeyDown={handlePeso}
                  onChange={(event) => {
                    event.preventDefault();
                  }}
                  onFocus={() => setPesoOnFocus(true)}
                  onBlur={() => setPesoOnFocus(false)}
                  readOnly
                  error={
                    peso !== "000000" &&
                    (parseInt(peso.slice(0, 3)) < 30 ||
                      parseInt(peso.slice(0, 3)) > 250)
                  }
                  required
                  helperText={"O peso deve estar entre 30kg e 250kg."}
                />

                <FieldInputText
                  label="IMC (Índice de massa corpórea)"
                  type="number"
                  disabled
                  value={imc}
                  setValue={(value) => {}}
                  helperText={" "}
                />
              </Stack>

              <Divider sx={{ mb: 2 }} />
              <Typography style={styles.subtitle}>Sinais e sintomas</Typography>
              <Stack component="label" direction="row" sx={styles.titleForms}>
                Selecione todos que se aplicam:
              </Stack>
              <Stack>
                <FormGroup
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                    boxSizing: "border-box !important",
                    marginBottom: "20px",
                    gap: "0px 24px",
                    gridAutoRows: "40px",

                    "& label span:first-of-type": {
                      color: "#3E94C2",
                    },
                  }}
                >
                  {sinaisSintomasList.map((item) => (
                    <FormControlLabel
                      key={item.value}
                      control={<Checkbox sx={{ color: "#3E94C2" }} />}
                      label={item.label}
                      value={item.value}
                      checked={sinaisSintomasOpcaoSelecionada(item.value)}
                      onClick={handleSinaisSintomas}
                    />
                  ))}
                  <Grid container direction="row" alignItems="center">
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Outros"
                      value="34"
                      checked={sinaisSintomasOpcaoSelecionada("34")}
                      onClick={handleSinaisSintomas}
                    />
                    <FieldInputText
                      label=""
                      value={sinaisSintomasOutros}
                      setValue={(value) => {
                        setSinaisSintomasOutros(value);
                      }}
                    />
                  </Grid>
                </FormGroup>
              </Stack>

              <Divider sx={{ mb: 2, mt: 2 }} />
              <Typography style={styles.subtitle}>
                Antecedente pessoais
              </Typography>
              <Stack direction="row" sx={styles.titleForms}>
                Selecione todos que se aplicam:
              </Stack>
              <Stack>
                <FormGroup
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                    boxSizing: "border-box !important",
                    marginBottom: "20px",
                    gap: "0px 24px",
                    gridAutoRows: "40px",

                    "& label span:first-of-type": {
                      color: "#3E94C2",
                    },
                  }}
                >
                  {antecedentepessoaisList.map((item) => (
                    <FormControlLabel
                      key={item.value}
                      control={<Checkbox />}
                      label={item.label}
                      value={item.value}
                      onClick={handleAntecedentes}
                      checked={antecedentesPessoaisSelecionada(item.value)}
                    />
                  ))}

                  <Grid container direction="row" alignItems="center">
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Outros"
                      value="34"
                      onClick={handleAntecedentes}
                      checked={antecedentesPessoaisSelecionada("34")}
                    />
                    <FieldInputText
                      label=""
                      value={antecedentesPessoaisOutros}
                      setValue={(value) => {
                        setAntecedentesPessoaisOutros(value);
                      }}
                    />
                  </Grid>
                </FormGroup>
              </Stack>

              <Divider sx={{ mb: 2, mt: 2 }} />
              <Typography style={styles.subtitle}>Comorbidades</Typography>
              <Stack direction="row" sx={styles.titleForms}>
                Selecione todos que se aplicam:
              </Stack>
              <Stack>
                <FormGroup
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                    boxSizing: "border-box !important",
                    marginBottom: "20px",
                    gap: "0px 24px",
                    gridAutoRows: "40px",

                    "& label span:first-of-type": {
                      color: "#3E94C2",
                    },
                  }}
                >
                  {comorbidadesList.map((item) => (
                    <FormControlLabel
                      key={item.value}
                      control={<Checkbox />}
                      label={item.label}
                      value={item.value}
                      checked={comorbidadeOpcaoSelecionada(item.value)}
                      onClick={handleComorbidades}
                    />
                  ))}
                </FormGroup>
              </Stack>

              <FieldAutocomplete
                label="Selecione outras comorbidades acometidas pelo paciente"
                multiple
                options={CIDList}
                getOptionLabel={(option) =>
                  `${option.co_categoria} - ${option.no_categoria}` || ""
                }
                freeSolo
                value={comorbidadesOutras}
                setValue={(e, newValue) => {
                  const uniqueValues = [
                    ...new Set(newValue.map((comorbidade) => comorbidade)),
                  ];
                  setComorbidadesOutras(uniqueValues);
                }}
                renderTags={() => null}
              />

              <Stack direction="row" flexWrap="wrap" sx={{ mt: 1 }}>
                {comorbidadesOutras.map((v) => (
                  <Chip
                    sx={{
                      background: "#D3E3EB",
                      color: "#1E729F",
                      margin: "4px",
                    }}
                    key={v.co_categoria}
                    label={mostrarLabelComorbidadesOutras(v)}
                    onDelete={(valor) => {
                      atualizarComorbidadesOutras(v);
                    }}
                  />
                ))}
              </Stack>

              <Divider sx={{ mb: 2, mt: 2 }} />
              <Typography style={styles.subtitle}>Cirurgias</Typography>

              <Stack
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  boxSizing: "border-box !important",
                  marginBottom: "20px",
                  gap: "16px 24px",
                  alignItems: "start",
                }}
              >
                <Stack>
                  <Stack direction="row" sx={styles.titleForms}>
                    Realizou cirurgias? <IconDiamond fill="#FC8518" />
                  </Stack>

                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="sim"
                      control={
                        <Radio
                          onChange={() =>
                            setCirurgias((prevState) => ({
                              ...prevState,
                              checked: true,
                            }))
                          }
                        />
                      }
                      label="Sim"
                      checked={cirurgias.checked}
                    />
                    <FormControlLabel
                      value="não"
                      control={
                        <Radio
                          onChange={() =>
                            setCirurgias((prevState) => ({
                              ...prevState,
                              checked: false,
                            }))
                          }
                        />
                      }
                      label="Não"
                      checked={cirurgias.checked === false}
                    />
                  </RadioGroup>
                </Stack>

                {cirurgias.checked && (
                  <>
                    <FieldInputText
                      label="Quais?"
                      setValue={(value) => {
                        setCirurgias((prevState) => ({
                          ...prevState,
                          qual: value,
                        }));
                      }}
                      placeholder="Digite"
                      value={cirurgias.qual}
                    />
                    <FieldDatePicker
                      label="Data da cirurgia"
                      setValue={handleChangeTempoCirurgia}
                      labelDatePicker={"mês de ano"}
                      openTo="year"
                      views={["year", "month"]}
                      maxDate={dayjs(new Date())}
                      minDate={dayjs(dataNascimento)}
                      format="MMMM YYYY"
                      value={cirurgias.dataCirurgia}
                    />

                    <Button
                      sx={{
                        height: "40px",
                        marginTop: "26px",
                      }}
                      variant="contained"
                      onClick={handleAdicionarCirurgia}
                    >
                      + Adicionar
                    </Button>
                  </>
                )}
              </Stack>
              <Stack direction="row" flexWrap="wrap" sx={{ mt: 1 }}>
                {cirurgias.tagCirurgias.map((v, index) => (
                  <Chip
                    sx={{
                      background: "#D3E3EB",
                      color: "#1E729F",
                      margin: "4px",
                    }}
                    key={index}
                    label={v}
                    onDelete={(valor) => {
                      setCirurgias((prevState) => ({
                        ...prevState,
                        tagCirurgias: cirurgias.tagCirurgias.filter(
                          (data) => data !== v
                        ),
                      }));
                    }}
                  />
                ))}
              </Stack>

              <Divider sx={{ mb: 2, mt: 2 }} />
              <Typography style={styles.subtitle}>
                Histórico familiar
              </Typography>

              <Stack
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
                  boxSizing: "border-box !important",
                  gap: "16px 24px",
                  color: "#333333",
                }}
              >
                <Stack width="100%">
                  <Stack direction="row" sx={styles.titleForms}>
                    Histórico familiar de doença psiquiátrica?
                  </Stack>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="sim"
                      control={
                        <Radio
                          onChange={() =>
                            setChecks((prevState) => ({
                              ...prevState,
                              historicoDoencaPsiquiatrica: true,
                            }))
                          }
                        />
                      }
                      label="Sim"
                      checked={checks.historicoDoencaPsiquiatrica}
                    />
                    <FormControlLabel
                      value="não"
                      control={
                        <Radio
                          onChange={() =>
                            setChecks((prevState) => ({
                              ...prevState,
                              historicoDoencaPsiquiatrica: false,
                            }))
                          }
                        />
                      }
                      label="Não"
                      checked={checks.historicoDoencaPsiquiatrica == false}
                    />
                  </RadioGroup>

                  {checks.historicoDoencaPsiquiatrica ? (
                    <>
                      <Stack direction="row" sx={styles.titleForms}>
                        Quem?
                      </Stack>
                      <Stack>
                        <FormGroup
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "repeat(2,1fr)",
                            boxSizing: "border-box !important",
                            gap: "0px 24px",
                            gridAutoRows: "40px",

                            "& label span:first-of-type": {
                              color: "#3E94C2",
                            },
                          }}
                        >
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Pai"
                            value="52"
                            onClick={handleHistoricoDoencaPsiquiatrica}
                            checked={historicoDoencaPsiquiatricaOpcaoSelecionada(
                              "52"
                            )}
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Mãe"
                            value="53"
                            onClick={handleHistoricoDoencaPsiquiatrica}
                            checked={historicoDoencaPsiquiatricaOpcaoSelecionada(
                              "53"
                            )}
                          />

                          <FormControlLabel
                            control={<Checkbox />}
                            label="Filho"
                            value="54"
                            onClick={handleHistoricoDoencaPsiquiatrica}
                            checked={historicoDoencaPsiquiatricaOpcaoSelecionada(
                              "54"
                            )}
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Irmão"
                            value="55"
                            onClick={handleHistoricoDoencaPsiquiatrica}
                            checked={historicoDoencaPsiquiatricaOpcaoSelecionada(
                              "55"
                            )}
                          />

                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outros"
                            value="34"
                            onClick={handleHistoricoDoencaPsiquiatrica}
                            checked={historicoDoencaPsiquiatricaOpcaoSelecionada(
                              "34"
                            )}
                          />
                          <FieldInputText
                            disabled={
                              !historicoFamiliarDoencaPsiquiatrica.includes(
                                "34"
                              )
                            }
                            type="text"
                            value={historicoDoencaPsiquiatricaOutros}
                            setValue={(value) =>
                              setHistoricoDoencaPsiquiatricaOutros(value)
                            }
                          />
                        </FormGroup>
                      </Stack>
                    </>
                  ) : (
                    ""
                  )}
                </Stack>

                <Stack width="100%">
                  <Stack direction="row" sx={styles.titleForms}>
                    Histórico familiar de ELA?
                  </Stack>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="sim"
                      checked={checks.historicoELA}
                      control={
                        <Radio
                          onChange={() =>
                            setChecks((prevState) => ({
                              ...prevState,
                              historicoELA: true,
                            }))
                          }
                        />
                      }
                      label="Sim"
                    />
                    <FormControlLabel
                      value="não"
                      checked={checks.historicoELA === false}
                      control={
                        <Radio
                          onChange={() =>
                            setChecks((prevState) => ({
                              ...prevState,
                              historicoELA: false,
                            }))
                          }
                        />
                      }
                      label="Não"
                    />
                  </RadioGroup>

                  {checks.historicoELA ? (
                    <>
                      <Stack direction="row" sx={styles.titleForms}>
                        Quem?
                      </Stack>
                      <Stack>
                        <FormGroup
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "repeat(2,1fr)",
                            boxSizing: "border-box !important",
                            gap: "0px 24px",
                            gridAutoRows: "40px",

                            "& label span:first-of-type": {
                              color: "#3E94C2",
                            },
                          }}
                        >
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Pai"
                            value="52"
                            checked={historicoELAOpcaoSelecionada("52")}
                            onClick={handleHistoricoFamiliarELA}
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Mãe"
                            value="53"
                            checked={historicoELAOpcaoSelecionada("53")}
                            onClick={handleHistoricoFamiliarELA}
                          />

                          <FormControlLabel
                            control={<Checkbox />}
                            label="Filho"
                            value="54"
                            checked={historicoELAOpcaoSelecionada("54")}
                            onClick={handleHistoricoFamiliarELA}
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Irmão"
                            value="55"
                            checked={historicoELAOpcaoSelecionada("55")}
                            onClick={handleHistoricoFamiliarELA}
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outros"
                            value="34"
                            checked={historicoELAOpcaoSelecionada("34")}
                            onClick={handleHistoricoFamiliarELA}
                          />
                          <FieldInputText
                            disabled={!historicoFamiliarELA.includes("34")}
                            value={historicoFamiliarELAOutros}
                            setValue={(value) => {
                              setHistoricoFamiliarELAOutros(value);
                            }}
                          />
                        </FormGroup>
                      </Stack>
                    </>
                  ) : (
                    ""
                  )}
                </Stack>

                <Stack width="100%">
                  <Stack direction="row" sx={styles.titleForms}>
                    Histórico familiar de demência?
                  </Stack>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="sim"
                      checked={checks.historicoDemencia}
                      control={
                        <Radio
                          onChange={() =>
                            setChecks((prevState) => ({
                              ...prevState,
                              historicoDemencia: true,
                            }))
                          }
                        />
                      }
                      label="Sim"
                    />
                    <FormControlLabel
                      value="não"
                      checked={checks.historicoDemencia === false}
                      control={
                        <Radio
                          onChange={() =>
                            setChecks((prevState) => ({
                              ...prevState,
                              historicoDemencia: false,
                            }))
                          }
                        />
                      }
                      label="Não"
                    />
                  </RadioGroup>

                  {checks.historicoDemencia ? (
                    <>
                      <Stack direction="row" sx={styles.titleForms}>
                        Quem?
                      </Stack>
                      <Stack>
                        <FormGroup
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "repeat(2,1fr)",
                            boxSizing: "border-box !important",
                            gap: "0px 24px",
                            gridAutoRows: "40px",

                            "& label span:first-of-type": {
                              color: "#3E94C2",
                            },
                          }}
                        >
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Pai"
                            value="52"
                            checked={historicoDemenciaOpcaoSelecionada("52")}
                            onClick={handleHistoricoFamiliarDemencia}
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Mãe"
                            value="53"
                            checked={historicoDemenciaOpcaoSelecionada("53")}
                            onClick={handleHistoricoFamiliarDemencia}
                          />

                          <FormControlLabel
                            control={<Checkbox />}
                            label="Filho"
                            value="54"
                            checked={historicoDemenciaOpcaoSelecionada("54")}
                            onClick={handleHistoricoFamiliarDemencia}
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Irmão"
                            value="55"
                            checked={historicoDemenciaOpcaoSelecionada("55")}
                            onClick={handleHistoricoFamiliarDemencia}
                          />
                          <FormControlLabel
                            control={<Checkbox />}
                            label="Outros"
                            value="34"
                            checked={historicoDemenciaOpcaoSelecionada("34")}
                            onClick={handleHistoricoFamiliarDemencia}
                          />
                          <FieldInputText
                            disabled={!historicoFamiliarDemencia.includes("34")}
                            value={historicoFamiliarDemenciaOutros}
                            setValue={(value) =>
                              setHistoricoFamiliarDemenciaOutros(value)
                            }
                          />
                        </FormGroup>
                      </Stack>
                    </>
                  ) : (
                    ""
                  )}
                </Stack>
              </Stack>

              <Divider sx={{ mb: 2, mt: 2 }} />
              <Typography style={styles.subtitle}>
                Medicamentos do paciente
              </Typography>

              <Stack
                direction={{ md: "row", sm: "column" }}
                spacing={4}
                sx={{ mb: 2 }}
              >
                <Stack>
                  <Stack direction="row" sx={styles.titleForms}>
                    Uso de riluzol? <IconDiamond fill="#FC8518" />
                  </Stack>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="sim"
                      checked={usoRiluzol.checked}
                      control={
                        <Radio
                          onChange={() =>
                            setUsoRiluzol((prevState) => ({
                              ...prevState,
                              checked: true,
                            }))
                          }
                        />
                      }
                      label="Sim"
                    />
                    <FormControlLabel
                      value="não"
                      checked={usoRiluzol.checked === false}
                      control={
                        <Radio
                          onChange={() =>
                            setUsoRiluzol((prevState) => ({
                              ...prevState,
                              checked: false,
                            }))
                          }
                        />
                      }
                      label="Não"
                    />
                  </RadioGroup>
                </Stack>

                {usoRiluzol.checked && (
                  <Stack>
                    <FieldDatePicker
                      label="Data de início do uso"
                      value={usoRiluzol.dataInicioUso}
                      setValue={(value) =>
                        setUsoRiluzol((prevState) => ({
                          ...prevState,
                          dataInicioUso: formatDateISO8601(value),
                        }))
                      }
                      required
                      maxDate={dayjs(new Date())}
                      minDate={dayjs(dataNascimento)}
                    />
                  </Stack>
                )}
              </Stack>

              <FieldAutocomplete
                label="Selecione os medicamentos usados pelo paciente"
                multiple
                options={medicamentosList}
                getOptionLabel={(option) => option.no_descricao || ""}
                freeSolo
                value={medicamentosUsados}
                setValue={(e, newValue) => {
                  const uniqueValues = [
                    ...new Set(
                      newValue.map((med) =>
                        med.no_descricao ? med.no_descricao : med
                      )
                    ),
                  ];

                  setMedicamentosUsados(uniqueValues);
                }}
                renderTags={() => null}
              />

              <Stack direction="row" flexWrap="wrap" sx={{ mt: 1 }}>
                {medicamentosUsados.map((v) => (
                  <Chip
                    sx={{
                      background: "#D3E3EB",
                      color: "#1E729F",
                      margin: "4px",
                    }}
                    key={v}
                    label={v}
                    onDelete={(value) => {
                      setMedicamentosUsados((prevState) => [
                        ...prevState.filter((data) => data !== v),
                      ]);
                    }}
                  />
                ))}
              </Stack>

              <Divider sx={{ mb: 2, mt: 2 }} />

              <Stack direction="row" sx={styles.titleForms}>
                Alergias ou reações adversas? <IconDiamond fill="#FC8518" />
              </Stack>

              <RadioGroup
                row
                aria-labelledby="alergiasOuReacoes"
                name="alergiasOuReacoes"
                onChange={(e) => {
                  setChecks((prevState) => ({
                    ...prevState,
                    alergiasOuReacoes: e.target.value === "true",
                  }));
                }}
                required
              >
                <FormControlLabel
                  value="true"
                  checked={checks.alergiasOuReacoes === true}
                  control={<Radio required />}
                  label="Sim"
                />
                <FormControlLabel
                  value="false"
                  checked={checks.alergiasOuReacoes === false}
                  control={<Radio required />}
                  label="Não"
                />
              </RadioGroup>

              {checks.alergiasOuReacoes && (
                <Stack>
                  <FormGroup
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr",
                      color: "#333333",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={() =>
                            setChecks((prevState) => ({
                              ...prevState,
                              alimentos: !prevState.alimentos,
                            }))
                          }
                        />
                      }
                      label="Alimentos"
                      checked={checks.alimentos}
                    />

                    {checks.alimentos && (
                      <>
                        <FieldAutocomplete
                          multiple
                          options={[]}
                          getOptionLabel={(option) => ""}
                          freeSolo
                          value={alergiasOuReacoes.alimentos}
                          setValue={(e, newValue) => {
                            const uniqueValues = [
                              ...new Set(newValue.map((item) => item)),
                            ];
                            setAlergiasOuReacoes((prevState) => ({
                              ...prevState,
                              alimentos: uniqueValues,
                            }));
                          }}
                          renderTags={() => null}
                          placeholder="Digite alimento"
                        />

                        <Stack
                          direction="row"
                          flexWrap="wrap"
                          overflow="overlay"
                          gap="4px"
                          pr="5px"
                          mt="10px"
                        >
                          {alergiasOuReacoes.alimentos.map((v) => (
                            <Chip
                              sx={{
                                background: "#D3E3EB",
                                color: "#1E729F",
                                margin: "4px",
                              }}
                              key={v}
                              label={v}
                              onDelete={(valor) => {
                                setAlergiasOuReacoes((prevState) => ({
                                  ...prevState,
                                  alimentos: alergiasOuReacoes.alimentos.filter(
                                    (data) => data !== v
                                  ),
                                }));
                              }}
                            />
                          ))}
                        </Stack>
                      </>
                    )}

                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={() =>
                            setChecks((prevState) => ({
                              ...prevState,
                              medicamentos: !prevState.medicamentos,
                            }))
                          }
                        />
                      }
                      label="Medicamentos"
                      checked={checks.medicamentos}
                    />

                    {checks.medicamentos && (
                      <>
                        <FieldAutocomplete
                          multiple
                          options={substanciasList}
                          getOptionLabel={(option) =>
                            option.no_substancia || ""
                          }
                          freeSolo
                          value={alergiasOuReacoes.medicamentos}
                          setValue={(e, newValue) => {
                            const uniqueValues = [
                              ...new Set(
                                newValue.map((med) =>
                                  med.no_substancia ? med.no_substancia : med
                                )
                              ),
                            ];
                            setAlergiasOuReacoes((prevState) => ({
                              ...prevState,
                              medicamentos: uniqueValues,
                            }));
                          }}
                          renderTags={() => null}
                          placeholder="Digite"
                        />

                        <Stack
                          direction="row"
                          flexWrap="wrap"
                          overflow="overlay"
                          gap="4px"
                          pr="5px"
                          mt="10px"
                        >
                          {alergiasOuReacoes.medicamentos.map((v) => (
                            <Chip
                              sx={{
                                background: "#D3E3EB",
                                color: "#1E729F",
                                margin: "4px",
                              }}
                              key={v}
                              label={v}
                              onDelete={(valor) => {
                                setAlergiasOuReacoes((prevState) => ({
                                  ...prevState,
                                  medicamentos:
                                    alergiasOuReacoes.medicamentos.filter(
                                      (data) => data !== v
                                    ),
                                }));
                              }}
                            />
                          ))}
                        </Stack>
                      </>
                    )}

                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={() =>
                            setChecks((prevState) => ({
                              ...prevState,
                              outros: !prevState.outros,
                            }))
                          }
                        />
                      }
                      label="Outros"
                      checked={checks.outros}
                    />

                    {checks.outros && (
                      <>
                        <FieldAutocomplete
                          multiple
                          options={[]}
                          getOptionLabel={(option) => ""}
                          freeSolo
                          value={alergiasOuReacoes.outros}
                          setValue={(e, newValue) => {
                            const uniqueValues = [
                              ...new Set(newValue.map((item) => item)),
                            ];
                            setAlergiasOuReacoes((prevState) => ({
                              ...prevState,
                              outros: uniqueValues,
                            }));
                          }}
                          renderTags={() => null}
                          placeholder="Digite"
                        />

                        <Stack
                          direction="row"
                          flexWrap="wrap"
                          overflow="overlay"
                          gap="4px"
                          pr="5px"
                          mt="10px"
                        >
                          {alergiasOuReacoes.outros.map((v) => (
                            <Chip
                              sx={{
                                background: "#D3E3EB",
                                color: "#1E729F",
                              }}
                              key={v}
                              label={v}
                              onDelete={(valor) => {
                                setAlergiasOuReacoes((prevState) => ({
                                  ...prevState,
                                  outros: alergiasOuReacoes.outros.filter(
                                    (data) => data !== v
                                  ),
                                }));
                              }}
                            />
                          ))}
                        </Stack>
                      </>
                    )}
                  </FormGroup>
                </Stack>
              )}

              <Divider sx={{ mb: 2, mt: 2 }} />

              <Stack sx={{ mb: 2 }}>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  sx={styles.titleForms}
                >
                  Observações
                </Grid>
                <textarea
                  value={observacoes}
                  onChange={(e) => setObservacoes(e.target.value)}
                  style={{
                    height: "5rem",
                    border: "1px solid #1E729F",
                    borderRadius: "5px",
                    padding: 10,
                    resize: "vertical",
                  }}
                  variant="outlined"
                />
              </Stack>

              <Stack
                direction="row"
                sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}
              >
                <Button
                  variant="outlined"
                  onClick={() =>
                    navigate(
                      generatePath(`/pacientes/prontuario/${idPaciente}`)
                    )
                  }
                >
                  Cancelar
                </Button>
                <Button variant="outlined" type="submit">
                  Finalizar
                </Button>
              </Stack>
            </form>
          </Box>
        </Box>
        <ModalDialogs
          open={stateModal.open}
          onClose={() =>
            setStateModal((prevState) => ({ ...prevState, open: false }))
          }
          modalType={stateModal.modalType}
          title={stateModal.title}
          body={stateModal.bodyText}
        />
        <ModalDialogs
          open={modalSuccess}
          onClose={() => setModalSuccess(false)}
          modalType="success"
          title={"Sucesso"}
          body={
            <>
              A primeira avaliação foi realizada com sucesso! <br />
              Você deseja realizar a primeira consulta do paciente?
            </>
          }
          onActionPrimary={() =>
            navigate(generatePath(`/pacientes/primeira-consulta/${idPaciente}`))
          }
          onActionSecondary={() =>
            navigate(generatePath(`/pacientes/prontuario/${idPaciente}`))
          }
          secondaryButtonText="Não"
          primaryButtonText="Sim"
        />
      </Box>
    );
  }
}
